import "./dashboard.css";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MembershipContext } from "hoc/membership-data";
import EmptyDashboard from "components/empty-state/dashboard/empty/empty-dashboard";
import MyDashboard from "components/my-dashboard";

const Dashboard = () => {
  const { t } = useTranslation();
  const membershipData = useContext(MembershipContext);
  const { teams } = membershipData;

  if (teams.length > 1) {
    // Display another component if multiple teams exist
  }

  const isEmpty = teams.length === 1 && !teams[0].is_in_championship;

  return (
    <div className="dashboard-container">
      <h1 className="title-1 mb-32">{t("dashboard.title")}</h1>
      {isEmpty ? (
        <EmptyDashboard></EmptyDashboard>
      ) : (
        <MyDashboard></MyDashboard>
      )}
    </div>
  );
};

export default Dashboard;
